"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThemeAction = void 0;
const server_runtime_1 = require("@remix-run/server-runtime");
const theme_provider_1 = require("./theme-provider");
const createThemeAction = (themeSessionResolver) => {
    const action = async ({ request }) => {
        const session = await themeSessionResolver(request);
        const { theme } = await request.json();
        if (!theme) {
            return (0, server_runtime_1.json)({ success: true }, { headers: { 'Set-Cookie': await session.destroy() } });
        }
        if (!(0, theme_provider_1.isTheme)(theme)) {
            return (0, server_runtime_1.json)({
                success: false,
                message: `theme value of ${theme} is not a valid theme.`,
            });
        }
        session.setTheme(theme);
        return (0, server_runtime_1.json)({ success: true }, {
            headers: { 'Set-Cookie': await session.commit() },
        });
    };
    return action;
};
exports.createThemeAction = createThemeAction;
